import { FoodConfigUnknownPresencePolicy, FoodProvisioningMode } from 'types/api/foodApi.interface'

export const FOOD_PROVISIONING_MODE_OPTIONS = [
  { label: 'Mess / Hall', value: FoodProvisioningMode.MessOrHall },
  { label: 'Packout', value: FoodProvisioningMode.Packout },
  { label: 'Opt-Out', value: FoodProvisioningMode.OptOut },
]

export const FOOD_UNKNOWN_PRESENCE_OPTIONS = [
  { label: 'No Meal', value: FoodConfigUnknownPresencePolicy.NoMeal },
  { label: 'Plan Meal', value: FoodConfigUnknownPresencePolicy.PlanMeal },
  { label: 'Standby Reserve', value: FoodConfigUnknownPresencePolicy.StandbyReserve },
]

export const foodProvisioningModeLabel = (mode: number) =>
  FOOD_PROVISIONING_MODE_OPTIONS.find((o) => o.value === mode)?.label || `Mode ${mode}`

export const foodUnknownPresencePolicyLabel = (policy: number) =>
  FOOD_UNKNOWN_PRESENCE_OPTIONS.find((o) => o.value === policy)?.label || `Unknown ${policy}`

const RECIPE_UNIT_NAMES = new Set([
  'g',
  'gr',
  'gram',
  'grams',
  'kg',
  'kilogram',
  'kilograms',
  'ml',
  'milliliter',
  'millilitre',
  'milliliters',
  'millilitres',
  'l',
  'lt',
  'liter',
  'litre',
  'liters',
  'litres',
  'pcs',
  'pc',
  'piece',
  'pieces',
])

export const isRecipeUnitName = (name?: string | null) => {
  const raw = String(name || '')
    .trim()
    .toLowerCase()
  if (!raw) return false
  const withoutParens = raw.replace(/\(.*?\)/g, '').trim()
  const parenToken = raw.match(/\(([^)]+)\)/)?.[1]?.trim()
  return (
    RECIPE_UNIT_NAMES.has(raw) ||
    RECIPE_UNIT_NAMES.has(withoutParens) ||
    (!!parenToken && RECIPE_UNIT_NAMES.has(parenToken))
  )
}

export const foodUserDisplayName = (user: any) => {
  if (user == null) return '—'
  if (typeof user === 'string' || typeof user === 'number') return String(user)
  const name = `${user.firstName || ''} ${user.lastName || ''}`.trim()
  return name || '—'
}
